import { SharedModule } from '@ajin/shared/modules/shared.module';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AuthMenuComponent } from './auth-menu.component';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
    declarations: [
        AuthMenuComponent
    ],
    imports     : [
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        SharedModule,
        TranslocoModule
    ],
    exports     : [
        AuthMenuComponent
    ]
})
export class AuthMenuModule
{
}
